import { jsx as _jsx } from "react/jsx-runtime";
import { getHostWithProtocol } from 'framework/globalStorage/contextStore';
import { Helmet } from 'react-helmet';
import { prependSearchCompareBasename } from 'utils/searchCompare';
const SiteLinksSearchBoxScript = ()=>{
    const host = getHostWithProtocol();
    const target = `${host}${prependSearchCompareBasename(`/results?q={q}`)}`;
    return /*#__PURE__*/ _jsx(Helmet, {
        children: /*#__PURE__*/ _jsx("script", {
            type: "application/ld+json",
            children: `
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "url": "${host}",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "${target}",
          "query-input": "required name=q"
        }
      }`
        })
    });
};
export default SiteLinksSearchBoxScript;
